package com.example.positionahead.data

actual fun fmpStableBaseUrl(): String = "/api/fmp"
